angular.module('userSettingsMod')

.controller('recycleBinCtrl', ['$scope', async function($scope) {
	$scope.loaderActive = true;
	$scope.appsForRecycleBin = []

	$scope.appsList = await gudhub.getAppsList();

	// Include hidden apps (show: false) too, since a trashed item can still need
	// restoring from an app the user has chosen to hide from the main app list.
	$scope.appsForRecycleBin = $scope.appsList.map(app => {

		return {
			fieldModel: {
				data_model: {
					app_id: app.app_id,
					icon: app.icon,
					name: app.app_name,
					mode: 'app'
				}
			}
		}
	})
	$scope.loaderActive = false

	$scope.$apply();

}]);
